/* =========================================================
   AF — Buy Actions Dock (PDP)
   File: assets/af-buy-actions.js

   Moves:
   - Share block (share-button / .share-button)
   Into: .af-buy-actions[data-af-buy-actions]
   ========================================================= */

(function () {
  function moveIntoDock(scope) {
    const productForm = scope.querySelector('product-form.product-form');
    if (!productForm) return;

    const dock = productForm.querySelector('[data-af-buy-actions]');
    if (!dock) return;

    // --------- Move Share ----------
    // Try common Dawn share block selectors
    const infoContainer =
      productForm.closest('.product__info-container') ||
      productForm.closest('#ProductInfo-' + (productForm.getAttribute('data-section-id') || '')) ||
      scope;

    const shareEl =
      (infoContainer && infoContainer.querySelector('share-button')) ||
      (infoContainer && infoContainer.querySelector('.share-button')) ||
      scope.querySelector('share-button') ||
      scope.querySelector('.share-button');

    if (shareEl && shareEl.parentElement !== dock) {
      shareEl.classList.add('af-action', 'af-action--share');
      dock.insertBefore(shareEl, dock.firstChild);
    }

    // --------- Move Wishlist ----------
    const wlBtn =
      (infoContainer && infoContainer.querySelector('.af-wl-btn--pdp')) ||
      scope.querySelector('.af-wl-btn--pdp');

    if (wlBtn && wlBtn.parentElement !== dock) {
      wlBtn.classList.add('af-action', 'af-action--wishlist');
      dock.appendChild(wlBtn);
    }
  }

  function init() {
    // Run once now
    document.querySelectorAll('product-info').forEach(moveIntoDock);

    // Re-run after apps / dynamic blocks inject (wishlist often injects late), but
    // do NOT scan the whole document on every mutation for the life of the page.
    // Debounce the work and disconnect once everything is docked (or after a short
    // cap by which late apps have injected), so ordinary interactions (cart drawer,
    // review re-sort, etc.) don't keep re-triggering full-document querySelectorAll.
    let scheduled = false;
    let obs;
    const stopAt = Date.now() + 10000;

    const run = () => {
      scheduled = false;
      document.querySelectorAll('product-info').forEach(moveIntoDock);
      const docks = document.querySelectorAll('[data-af-buy-actions]');
      let allDocked = docks.length > 0;
      docks.forEach((d) => {
        if (!d.querySelector('.af-action--wishlist')) allDocked = false;
      });
      if ((allDocked || Date.now() > stopAt) && obs) obs.disconnect();
    };

    obs = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      setTimeout(run, 100);
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
